export default __webpack_public_path__ + "static/media/renew-code--desktop.9ca430cb.jpg";